import { render, staticRenderFns } from "./GradeForm.vue?vue&type=template&id=36922dff&"
import script from "./GradeForm.ts?vue&type=script&lang=js&"
export * from "./GradeForm.ts?vue&type=script&lang=js&"
import style0 from "./GradeForm.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports